import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { DataService } from 'app/common/_services/data.service';
import { BranchEndpointService } from 'app/common/_services/branch-endpoint.service';
import { GlobalVariables } from '../global';
import { handleApiErrors } from '../_utils/api.util';
import { GetSignInResponse, LoginFormData } from './../_types/api.types';

@Injectable()
export class AuthEndpointsService {
  private authUrl = GlobalVariables.BASE_API_URL + '/api/v1/sessions';
  public isLoggedIn: boolean = !!this.dataService.sessionData();
  public redirectUrl?: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private dataService: DataService,
  ) {}

  login(formData: LoginFormData) {
    const loginUrl = this.authUrl;

    return this.http.post<GetSignInResponse>(loginUrl, { account: formData }).pipe(
      catchError((err) => {
        return handleApiErrors(err);
      }),
      map((response: GetSignInResponse) => {
        try {
          if (!response?.data?.attributes) {
            throw new Error('Invalid login response: missing data');
          }

          const { attributes, relationships } = response.data;

          this.isLoggedIn = true;

          this.dataService.setSessionData(attributes.accessToken);
          this.dataService.setCompanyLogo(attributes.logo);

          if (relationships?.branch?.data?.id) this.dataService.setBranchData(relationships.branch.data.id);

          if (this.redirectUrl) {
            this.router.navigate([this.redirectUrl]);
            this.redirectUrl = '';
          }

          return response;
        } catch (err) {
          console.error('[AuthEndpointsService.login] Error processing response:', err, response);
          throw err;
        }
      }),
    );
  }

  logout() {
    const loginUrl = this.authUrl;
    this.isLoggedIn = false;

    return this.http.delete(loginUrl).pipe(catchError((err) => handleApiErrors(err)));
  }
}
